// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"af997fe9","486":"982bb6d3","787":"43d7ac32","861":"3db060df","880":"9b9585d3"}[chunkId] + ".chunk.js";
};